import React from "react";
import ModalFormEstacion from "./ModalFormEstacion";

const ModalEstacion = ({ show, handleClose, estacion }) => {
  return (
    <ModalFormEstacion show={show} handleClose={handleClose} estacion={estacion} />
  );
};

export default ModalEstacion;
